import React from "react";
import "./card-style.css";

const CardImage = ({ source }) => <div className="card"><img className="card-content" src={source} /></div>

export default CardImage;